import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import { EVENT_TEMPLATES_CDN_URL, isMobileNotTabletDevice } from "../../../Utils";
import "./index.css";

// Helper function to format name with last initial
const formatNameWithLastInitial = (firstName, lastName) => {
    if (!firstName || !lastName) return firstName || lastName || "";

    // Split the last name in case it has multiple parts
    const lastNameParts = lastName.trim().split(" ");
    // Take the very last part of the last name
    const finalLastName = lastNameParts[lastNameParts.length - 1];
    // Get the initial of the final last name
    const lastInitial = finalLastName.charAt(0).toUpperCase();

    return `${firstName} ${lastInitial}`;
};

// Helper function to format accompanying users
const formatAccompanyingUsers = (accompanyingUsers) => {
    if (!accompanyingUsers) return "";

    return accompanyingUsers.split(",").map(user => {
        const [firstName, ...lastNames] = user.trim().split(" ");
        if (!lastNames.length) return firstName;

        const lastName = lastNames[lastNames.length - 1];
        return formatNameWithLastInitial(firstName, lastName);
    }).join(", ");
};

export default function Participant({ themeId, guestData }) {
    // console.log("guestData", guestData);
    const [participantBgImgSrc, setParticipantBgImgSrc] = useState("");
    const [participantBgWidth, setParticipantBgWidth] = useState("751px");
    const [participantBgHeight, setParticipantBgHeight] = useState("283px");
    const [isMobile, setIsMobile] = useState(isMobileNotTabletDevice());

    useEffect(() => {
        function handleResize() {
            setIsMobile(isMobileNotTabletDevice());
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <div className={isMobile ? "container-fluid ps-0 pe-0" : "container"}>
            <Row>
                <Col sm={12} className="mb-3 text-center">
                    <div className="position-relative">
                        <div className="position-relative">
                            <p className="participantName">
                                {formatNameWithLastInitial(guestData.first_name, guestData.last_name)}
                            </p>
                            {guestData?.accompanying_users && (
                                <p className="accompanyingName">
                                    Accompanying Guest: {formatAccompanyingUsers(guestData.accompanying_users)}
                                </p>
                            )}
                            {guestData && guestData.section && guestData.section === "VIP" && (
                                <p className="youare">You are our VIP guest</p>
                            )}
                            
                            {/* <div className="totalTicketPurchasedContainer">
                                <div className="totalTicketPurchasedBox">
                                    <div className="d-flex justify-content-center gap-5 totalTicketPurchasedDiv">
                                        <p className="ticketPurchasedText">
                                        Guest Count
                                        </p>
                                        <p className="ticketPurchasedCount">
                                            {guestData?.attendee_count ? guestData?.attendee_count : 1}
                                        </p>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
}